import React, { useState, useEffect } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import Button from "../../components/Button";
import loginLogo from "../../assets/images/ConfieIQLogo09042023.svg";
import { useMutation, useQuery } from "react-query";
import { checkLogin } from "../../actions/Login";
import { getMydata, ssoLogin } from "../../actions/Login";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { accountAtom, loginError } from "./atoms/AccountAtom";
import { useRecoilState, useSetRecoilState } from "recoil";

export const LoginSSO = () => {
  const {
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [errorMessage, setLoginError] = useRecoilState(loginError);

  const mutation = useMutation(ssoLogin);
  const history = useHistory();

  const [account, setAccount] = useRecoilState(accountAtom);

  const { data: myData, isLoading: getUserLoading } = useQuery(
    "me",
    getMydata,
    {
      refetchOnWindowFocus: false,
      enabled: cookies.token && cookies.emailAddress ? true : false,
    },
  );
  //Handles Submit Login
  // useEffect(() => {
  //   if (cookies.token && cookies.emailAddress) {
  //     // localStorage.setItem("token", cookies.token);
  //     localStorage.setItem("username", cookies.username);
  //     // removeCookie("token", { path: "/", domain: "localhost" });
  //     // removeCookie("username", { path: "/", domain: "localhost" });
  //     removeCookie("token", { path: "/", domain: ".stg-inquiry.confie.com" });
  //     removeCookie("username", {
  //       path: "/",
  //       domain: ".stg-inquiry.confie.com",
  //     });
  //     window.location.reload();
  //     history.push("/home");
  //   } else if (cookies.loginerror) {
  //     setLoginError(`There was an error logging in. ${cookies.loginerror}`);
  //     setCookie("loginerror", "");
  //   }
  // }, [cookies, history]);
  // useEffect(() => {
  //   if (myData && account.emailAddress) {
  //     if (myData.status !== 200) {
  //       localStorage.clear();
  //       setLoginError(
  //         "Server Error: Failed to login, please contact your administrator."
  //       );
  //       history.push("/");
  //     } else if (myData.status === 200) {
  //       setAccount(myData.data);
  //       history.push("/home");
  //     }
  //   }
  // }, [myData]);
  useEffect(() => {
    if (account.emailAddress) {
      if (!account.emailAddress) {
        localStorage.clear();
        setLoginError(
          "Server Error: Failed to login, please contact your administrator.",
        );
        history.push("/");
      } else {
        //setAccount(myData.data);
        history.push("/home");
      }
    }
  }, [account]);

  const { data } = useQuery("login", ssoLogin, {
    enabled: submitted,
    onSettled: () => setSubmitted(false),
  });

  if (data?.data?.url) {
    window.location.href = data.data.url;
  }

  const onSubmit = () => {
    setSubmitted(true);
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="containerLogin bg-white rounded-3xl h-3/6 border border-gray-200 shadow-xl sm:p-14 p-10 justify-center flex items-center divide sm:divide-x divide-x-0 sm:divide-y-0 divide-y 2xl:w-5/12 xl:w-6/12 lg:w-8/12 md:w-10/12 md:mx-0 mx-8 w-full sm:flex-row flex-col sm:space-y-0 space-y-5 ">
        <div className="w-full flex-1 flex justify-center items-center flex-col space-y-4 sm:pr-8 px-5">
          <img src={loginLogo} className="w-full object-cover" alt="logo" />
        </div>
        <form
          className="flex-1 space-y-4 sm:pl-8 pl-0  sm:pt-0 pt-5 "
          onSubmit={handleSubmit(onSubmit)}
        >
          <button
            className={
              (mutation.isLoading
                ? "opacity-50 cursor-default"
                : "opacity-100") +
              " rounded-full bg-primary uppercase w-full text-white sm:text-xs shadow-2xl h-7"
            }
          >
            <div className="flex justify-center items-center">
              <div
                className={
                  mutation.isLoading || getUserLoading
                    ? "spinner-border animate-spin inline-block w-4 h-4 mr-2 border-2 rounded-full"
                    : ""
                }
                role="status"
              ></div>
            </div>

            {mutation.isLoading || getUserLoading
              ? "Signing in.."
              : "Login thru PingID"}
          </button>
          {errorMessage && (
            <div className="flex whitespace-no-wrap mt-4 text-xs text-red-500 font-semibold">
              {" "}
              <i className="align-middle mr-4">
                <ExclamationTriangleIcon className="h-4 w-4 -mr-2" />
              </i>{" "}
              <span> {errorMessage} </span>{" "}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};
